export interface DesignConfiguration {
    borderRadius: string;
    cssOverrideCode: string;
    genColorBodyBgColor: string;
    genColorBodyBgIframe: string;
    genColorDanger: string;
    genColorInfo: string;
    genColorPrimary: string;
    genColorSecondary: string;
    genColorSuccess: string;
    genImageExpertshareLogo: string;
    genImageFavicon: string;
    genImageMainLogo: string;
    genImageNavigationLogo: string;
    genImageBackgroundLogin: string;
    isEnable3dLayout: string;
    loginLogo: string;
    menuOption: string;
    navBgColor: string;
    navItemBgColor: string;
    navItemBgColorActive: string;
    navItemBgColorHover: string;
    navItemIconColor: string;
    navItemIconColorActive: string;
    navItemIconColorHover: string;
    navItemTextColor: string;
    navItemTextColorActive: string;
    navItemTextColorHover: string;
    primaryColor: string;
    widAgRowEvenBgColor: string;
    widAgRowOddBgColor: string;
    widAgRowTextColor: string;
    widAgHeaderBgColor: string;
    widCardBgColor: string;
    widCardBorderRadius: string;
    widCardBoxShadowColor: string;
    widCardDividerColor: string;
    widCardTextColor: string;
    widModalBackdropBgColor: string;
    widModalBgColor: string;
    widModalBorderRadius: string;
    widModalTextColor: string;
    widPipBorderRadius: string;
    widTabBgColor: string;
    widTabBgColorActive: string;
    widTabBorderRadius: string;
    widTabBoxShadowColor: string;
    widTabBoxShadowColorActive: string;
    widTabTextColor: string;
    widTabTextColorActive: string;
    widTagBorderRadius: string;
    navPosition: string;
    containerFluid: boolean;
    navFeaturedMoreIcon: string;
    navFeaturedItems: number;
    defImageAttendee: string;
    defImageContainer: string;
    defImageDocument: string;
    defImageElCourse: string;
    defImageElTask: string;
    defImageEvent: string;
    defImageExhibitor: string;
    defImageExhibitorProduct: string;
    defImageSession: string;
    defImageVideoGallery: string;
    genPublicPageBanner: string;
}

export class DesignConfiguration {
    borderRadius = "";

    cssOverrideCode = "";

    genColorBodyBgColor = "";

    genColorBodyBgIframe = "";

    genColorDanger = "";

    genColorInfo = "";

    genColorPrimary = "";

    genColorSecondary = "";

    genColorSuccess = "";

    genImageExpertshareLogo = "";

    genImageFavicon = "";

    genImageMainLogo = "";

    genImageNavigationLogo = "";

    genImageBackgroundLogin = "";

    isEnable3dLayout = "";

    loginLogo = "";

    menuOption = "";

    navBgColor = "";

    navItemBgColor = "";

    navItemBgColorActive = "";

    navItemBgColorHover = "";

    navItemIconColor = "";

    navItemIconColorActive = "";

    navItemIconColorHover = "";

    navItemTextColor = "";

    navItemTextColorActive = "";

    navItemTextColorHover = "";

    primaryColor = "";

    widAgRowEvenBgColor = "";

    widAgRowOddBgColor = "";

    widAgRowTextColor = "";

    widAgHeaderBgColor = "";

    widCardBgColor = "";

    widCardBorderRadius = "";

    widCardBoxShadowColor = "";

    widCardDividerColor = "";

    widCardTextColor = "";

    widModalBackdropBgColor = "";

    widModalBgColor = "";

    widModalBorderRadius = "";

    widModalTextColor = "";

    widPipBorderRadius = "";

    widTabBgColor = "";

    widTabBgColorActive = "";

    widTabBorderRadius = "";

    widTabBoxShadowColor = "";

    widTabBoxShadowColorActive = "";

    widTabTextColor = "";

    widTabTextColorActive = "";

    widTagBorderRadius = "";

    navPosition = "";

    containerFluid = false;

    navFeaturedMoreIcon = "";

    navFeaturedItems = 3;

    defImageAttendee = "";

    defImageContainer = "";

    defImageDocument = "";

    defImageElCourse = "";

    defImageElTask = "";

    defImageEvent = "";

    defImageExhibitor = "";

    defImageExhibitorProduct = "";

    defImageSession = "";

    defImageVideoGallery = "";

    genPublicPageBanner = "";
}
